export enum BucketType {
  Documents = 'documents',
  Branding = 'branding',
}
